import apiService from "../../api/api.service";
import { CountriesResponse } from "./countries.types";

export const fetchCountries = () => {
  return apiService.get<CountriesResponse>("/general/countries");
};
